import DefaultLayout from "../../components/layout/DefaultLayout"

const Settings = () => {
  return <DefaultLayout>Under Development</DefaultLayout>
}
export default Settings
